/**
 * Цвет текста ошибки, читаемый на заданном фоне (аудит удобства 2026-10-04, п. 37).
 *
 * <p><b>Что было.</b> Ошибки входа писались бледно-розовым `#fca5a5` на любой теме — на белой
 * карточке светлой темы это контраст около 1,9:1, то есть «Неверный пароль» почти не видно.
 *
 * <p><b>Как решает.</b> По яркости фона карточки: на светлом — тёмно-красный `#b91c1c`
 * (≈6,5:1 на белом), на тёмном — тот же розовый, что и был (≈7:1 на `#1e293b`). Считаем по
 * фону, а не по имени темы: тем пять, и следующая новая тема не должна забыть про этот цвет.
 */
export const ERROR_ON_LIGHT = '#b91c1c';
export const ERROR_ON_DARK = '#fca5a5';

/** Относительная яркость по WCAG 2.x; на нераспознанном цвете — `null`. */
export function relativeLuminance(hex: string): number | null {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;
  const h = m[1]!.length === 3 ? m[1]!.replace(/./g, (c) => c + c) : m[1]!;
  const channel = (i: number) => {
    const v = parseInt(h.slice(i, i + 2), 16) / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * channel(0) + 0.7152 * channel(2) + 0.0722 * channel(4);
}

export function readableErrorColor(background: string): string {
  const l = relativeLuminance(background);
  // Нераспознанный фон (rgba, имя цвета) — считаем тёмным: все такие фоны у нас тёмные.
  return l !== null && l > 0.4 ? ERROR_ON_LIGHT : ERROR_ON_DARK;
}
